<template>
  <LicenseWorkflowEditorCard :city="city" />
  <LicenseExpirationPolicyCard :city="city" />
  <LicenseStatusEmailSettingsCard :city="city" />
  <LicenseApplicationEditorCard :city="city" />
</template>

<script>
import {City} from "@/models/City";
import LicenseWorkflowEditorCard from "@/components/admin-city/licenses/LicenseWorkflowEditorCard.vue";
import LicenseApplicationEditorCard from "@/components/admin-city/licenses/LicenseApplicationEditorCard.vue";
import LicenseStatusEmailSettingsCard from "@/components/admin-city/licenses/LicenseStatusEmailSettingsCard.vue";
import LicenseExpirationPolicyCard from "@/components/admin-city/licenses/LicenseExpirationPolicyCard.vue";

export default {
  components: {LicenseApplicationEditorCard, LicenseStatusEmailSettingsCard, LicenseWorkflowEditorCard, LicenseExpirationPolicyCard},
  props: {
    city: City
  }
}
</script>
